<template>
  <ReviewItemDetailsLayout
    :review-item="fsn"
    :expansion-panel="expansionPanel"
    :item-url="fsn.metadata.link"
    :show-quarantined="false"
  >
    <template #subtitle>
      <p class="text-sm text-neutral-text-subtitle">
        {{ fsn.metadata.fsnType }}
      </p>
    </template>
  </ReviewItemDetailsLayout>
</template>

<script setup lang="ts">
import ReviewItemDetailsLayout from './ReviewItemDetailsLayout.vue'
import { FieldSafetyNotice } from '@core/domain/models/fieldSafetyNotice.model'
import useExpansionPanel from '@app/composables/use-expansion-panel'

defineProps<{
  fsn: FieldSafetyNotice
  expansionPanel: ReturnType<typeof useExpansionPanel>
}>()
</script>
